import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestPluginUpdateGet = {
  path: "/plugin-update/:slug",
  method: RouteHttpVerb.GET
};